module.exports = __webpack_public_path__ + "static/media/hospital-medical-plus-svgrepo-com.eab2cbdf.svg";